"use client";
import CommonTitle from "@/components/common/CommonTitle";
import CommonSubtitle from "../../common/CommonSubtitle";
import bgHeroImage from "@/assets/images/ai/ai-agent/hero-background.svg";
import { BookDemoHubspotButtonUrl, SignUpHubspotButtonUrl } from "@/utils/hubspot-contants";
import { ItemInfoProps } from "@/app/ai/ai-agent/root";
import CustomButton from "@/components/common/CustomButton";
import Image from "next/image";

const AiTop = ({ itemInfo }: { itemInfo: ItemInfoProps }) => {
  return (
    <>
      <section className="relative z-10 overflow-hidden">
        <div className="pt-[72px]">
          <div
            className="xl:pb-[100px] xl:pt-[76px]"
            style={{
              background: `url(${bgHeroImage.src})`,
              backgroundColor: "#ffffff",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div className="container relative z-10 mx-auto px-4">
              <div className="flex flex-col items-start gap-8 py-16 xlg:flex-row xlg:items-center xlg:gap-12 xl:py-0">
                <div className="flex w-full flex-col gap-6 sm:gap-8">
                  {itemInfo.contextualTag && (
                    <div className="inline-flex w-fit rounded-full bg-[#F3F3F3] px-3 py-1 text-sm font-semibold">
                      <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
                        {itemInfo.contextualTag}
                      </span>
                    </div>
                  )}
                  {itemInfo.introText && (
                    <CommonTitle
                      as="h1"
                      color="#202020"
                      fontSizeClass="text-[36px] lg:text-[48px] max-w-[580px]"
                      fontWeightClass="font-bold"
                    >
                      {itemInfo.introText}
                    </CommonTitle>
                  )}
                  {itemInfo.descriptionText && (
                    <CommonSubtitle color="#202020" fontSizeWeight="text-[16px]">
                      {itemInfo.descriptionText}
                    </CommonSubtitle>
                  )}
                  <div className="flex flex-wrap items-center gap-4">
                    <CustomButton
                      text="Try Kroolo for FREE"
                      url={SignUpHubspotButtonUrl}
                      target="_blank"
                      version="black"
                      variant="primary"
                    />
                    <CustomButton
                      text="Request a Demo"
                      url={BookDemoHubspotButtonUrl}
                      target="_blank"
                      variant="secondary"
                      version="black"
                    />
                  </div>
                </div>
                <div className="relative h-[460px] w-full overflow-hidden">
                  <Image
                    src={itemInfo.bannerImg || ""}
                    alt="Kroolo AI agents - Custom AI assistants hero"
                    className="h-full w-full object-contain"
                    layout="fill"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AiTop;
